export default __webpack_public_path__ + "static/media/sub-topic-model-05.227a28ac.glb";